import React, { createContext, useContext, useState, useEffect } from 'react';

// Translation data
const translations = {
  it: {
    // Navigation
    home: "Home",
    biography: "Biografia",
    horses: "Cavalli",
    news: "News",
    blog: "Blog",
    photos: "Foto",
    shop: "Shop",
    sponsors: "Sponsor",
    calendar: "Calendario",
    calendarTitle: "Calendario Gare",
    calendarSubtitle: "Tutti i concorsi della stagione e i risultati ottenuti",
    seasonTab: "Stagione 2026",
    addToCalendar: "Aggiungi al calendario",
    downloadSeason: "Scarica tutta la stagione (.ics)",
    downloadUpcoming: "Scarica i prossimi concorsi (.ics)",
    viewResults: "Vedi risultati",
    completed: "Disputato",
    upcomingShows: "Prossimi concorsi",
    pastShows: "Risultati",
    readNews: "Leggi la news",
    horsesInAction: "Cavalli",
    noUpcoming: "Nessun concorso in programma",
    calendarStats: "La stagione in numeri",
    winsLabel: "Vittorie",
    podiumsLabel: "Podi",
    showsLabel: "Concorsi",
    upcomingLabel: "In programma",
    
    // Home page
    internationalRider: "CAVALIERE INTERNAZIONALE",
    quote: "Improve 1% in 100 things and it will be a 100% improvement",
    improvement: "100% improvement",
    feiRanking: "FEI LONGINES RANKING",
    worldRanking: "World Ranking 2026",
    followers: "followers",
    nextEvents: "Prossimi eventi",
    lastNews: "Ultime news",
    lastResults: "Ultimi risultati",
    seeAll: "Vedi tutti",
    competitionHorses: "Cavalli da competizione",
    followTheJourney: "Segui il Viaggio",
    followJourneyDesc: "Rimani aggiornato con risultati delle gare, momenti dietro le quinte e contenuti esclusivi dal mondo del salto ostacoli.",
    follow: "SEGUI",
    partnersAndSponsors: "Partner & Sponsor",
    viewAllSponsors: "Vedi tutti gli sponsor",
    
    // Biography
    fromZeroToHero: "FROM ZERO TO HERO",
    yearsExperience: "Anni di esperienza",
    internationalWins: "Vittorie FEI",
    competitionHorsesCount: "Cavalli da competizione",
    excellence: "Eccellenza",
    excellenceDesc: "Puntare alla perfezione in ogni gara, spingendo costantemente i confini del possibile",
    partnership: "Partnership",
    partnershipDesc: "Costruire relazioni profonde e di fiducia con i cavalli basate sul rispetto e la comprensione reciproca",
    pride: "Orgoglio",
    prideDesc: "Rappresentare l'Italia con onore sulla scena internazionale e ispirare la prossima generazione",
    careerAchievements: "Traguardi della Carriera",
    highlightsFromCompetitions: "Momenti salienti dalle competizioni internazionali",
    myValues: "I Miei Valori",
    whatDrivesMe: "Cosa mi guida nello sport equestre",
    
    // Horses
    myHorses: "I Miei Cavalli",
    theIncredibleAthletes: "Gli incredibili atleti con cui gareggio",
    viewProfile: "Vedi profilo",
    horseNotFound: "Cavallo non trovato",
    backToHorses: "Torna ai Cavalli",
    breed: "Razza",
    born: "Nato",
    sire: "Padre",
    gender: "Sesso",
    dam: "Madre",
    damSire: "Padre della Madre",
    feiStarts: "Partenze FEI",
    wins: "Vittorie",
    achievements: "Traguardi",
    
    // News
    latestNews: "Ultime News",
    competitionResults: "Risultati e aggiornamenti delle competizioni",
    all: "Tutti",
    competitionResultsCat: "Risultati",
    teamSelection: "Selezione Team",
    competitionUpdates: "Aggiornamenti",
    articleNotFound: "Articolo non trovato",
    backToNews: "Torna alle News",
    
    // Blog
    blogTitle: "Blog",
    insightsFromArena: "Approfondimenti dall'arena",
    postNotFound: "Articolo non trovato",
    backToBlog: "Torna al Blog",
    
    // Photos
    photoGallery: "Galleria Foto",
    momentsFromArena: "Momenti dall'arena",
    competition: "Competizione",
    training: "Allenamento",
    
    // Shop
    officialShop: "Shop Ufficiale",
    premiumMerchandise: "Merchandising e abbigliamento premium",
    availableSoon: "DISPONIBILE PRESTO",
    shopComingSoonDesc: "Stiamo preparando qualcosa di speciale per te. Il nostro shop ufficiale aprirà presto con merchandising esclusivo e abbigliamento premium.",
    stayTuned: "Resta aggiornato",
    
    // Sponsors
    ourSponsors: "I Nostri Sponsor",
    partnersInExcellence: "Partner nell'eccellenza",
    sponsorsIntro: "Il successo ai massimi livelli del salto ostacoli richiede partnership eccezionali. Sono orgoglioso di lavorare con marchi di livello mondiale che condividono il mio impegno per l'eccellenza, l'innovazione e il benessere dei nostri cavalli.",
    mainSponsors: "MAIN SPONSORS",
    newPartners: "NEW PARTNERS 2026",
    interestedInPartnership: "Interessato a una Partnership?",
    partnershipCTA: "Sono sempre aperto a collaborare con marchi che condividono i miei valori e l'impegno per l'eccellenza nello sport equestre.",
    contactMe: "CONTATTAMI",
    
    // Footer
    navigate: "NAVIGA",
    more: "ALTRO",
    connect: "CONTATTI",
    footerDesc: "Cavaliere internazionale italiano che compete ai massimi livelli dello sport equestre.",
    poweredBy: "Powered by",
    allRightsReserved: "Tutti i diritti riservati.",
    
    // Common
    readMore: "Leggi di più",
    loading: "Caricamento...",
    new: "NOVITÀ",
    italy: "Italia"
  },
  en: {
    // Navigation
    home: "Home",
    biography: "Biography",
    horses: "Horses",
    news: "News",
    blog: "Blog",
    photos: "Photos",
    shop: "Shop",
    sponsors: "Sponsors",
    calendar: "Calendar",
    calendarTitle: "Show Calendar",
    calendarSubtitle: "All the shows of the season and the results achieved",
    seasonTab: "Season 2026",
    addToCalendar: "Add to calendar",
    downloadSeason: "Download full season (.ics)",
    downloadUpcoming: "Download upcoming shows (.ics)",
    viewResults: "View results",
    completed: "Completed",
    upcomingShows: "Upcoming shows",
    pastShows: "Results",
    readNews: "Read the news",
    horsesInAction: "Horses",
    noUpcoming: "No upcoming shows scheduled",
    calendarStats: "Season at a glance",
    winsLabel: "Wins",
    podiumsLabel: "Podiums",
    showsLabel: "Shows",
    upcomingLabel: "Upcoming",
    
    // Home page
    internationalRider: "INTERNATIONAL RIDER",
    quote: "Improve 1% in 100 things and it will be a 100% improvement",
    improvement: "100% improvement",
    feiRanking: "FEI LONGINES RANKING",
    worldRanking: "World Ranking 2026",
    followers: "followers",
    nextEvents: "Next events",
    lastNews: "Latest news",
    lastResults: "Latest results",
    seeAll: "See all",
    competitionHorses: "Competition Horses",
    followTheJourney: "Follow the Journey",
    followJourneyDesc: "Stay updated with competition results, behind-the-scenes moments, and exclusive content from the world of showjumping.",
    follow: "FOLLOW",
    partnersAndSponsors: "Partners & Sponsors",
    viewAllSponsors: "View all sponsors",
    
    // Biography
    fromZeroToHero: "FROM ZERO TO HERO",
    yearsExperience: "Years Experience",
    internationalWins: "FEI Wins",
    competitionHorsesCount: "Competition Horses",
    excellence: "Excellence",
    excellenceDesc: "Striving for perfection in every round, constantly pushing the boundaries of what's possible",
    partnership: "Partnership",
    partnershipDesc: "Building deep, trusting relationships with horses based on mutual respect and understanding",
    pride: "Pride",
    prideDesc: "Representing Italy with honor on the international stage and inspiring the next generation",
    careerAchievements: "Career Achievements",
    highlightsFromCompetitions: "Highlights from international competitions",
    myValues: "My Values",
    whatDrivesMe: "What drives me in equestrian sport",
    
    // Horses
    myHorses: "My Horses",
    theIncredibleAthletes: "The incredible athletes I partner with",
    viewProfile: "View Profile",
    horseNotFound: "Horse not found",
    backToHorses: "Back to Horses",
    breed: "Breed",
    born: "Born",
    sire: "Sire",
    gender: "Gender",
    dam: "Dam",
    damSire: "Dam Sire",
    feiStarts: "FEI Starts",
    wins: "Wins",
    achievements: "Achievements",
    
    // News
    latestNews: "Latest News",
    competitionResults: "Competition results and updates",
    all: "All",
    competitionResultsCat: "Competition Results",
    teamSelection: "Team Selection",
    competitionUpdates: "Competition Updates",
    articleNotFound: "Article not found",
    backToNews: "Back to News",
    
    // Blog
    blogTitle: "Blog",
    insightsFromArena: "Insights from the arena",
    postNotFound: "Post not found",
    backToBlog: "Back to Blog",
    
    // Photos
    photoGallery: "Photo Gallery",
    momentsFromArena: "Moments from the arena",
    competition: "Competition",
    training: "Training",
    
    // Shop
    officialShop: "Official Shop",
    premiumMerchandise: "Premium merchandise and apparel",
    availableSoon: "AVAILABLE SOON",
    shopComingSoonDesc: "We're preparing something special for you. Our official shop will open soon with exclusive merchandise and premium apparel.",
    stayTuned: "Stay tuned",
    
    // Sponsors
    ourSponsors: "Our Sponsors",
    partnersInExcellence: "Partners in excellence",
    sponsorsIntro: "Success at the highest levels of showjumping requires exceptional partnerships. I'm proud to work with world-class brands who share my commitment to excellence, innovation, and the welfare of our horses.",
    mainSponsors: "MAIN SPONSORS",
    newPartners: "NEW PARTNERS 2026",
    interestedInPartnership: "Interested in a Partnership?",
    partnershipCTA: "I'm always open to collaborating with brands that share my values and commitment to excellence in equestrian sport.",
    contactMe: "CONTACT ME",
    
    // Footer
    navigate: "NAVIGATE",
    more: "MORE",
    connect: "CONNECT",
    footerDesc: "Italian international showjumping rider competing at the highest levels of equestrian sport.",
    poweredBy: "Powered by",
    allRightsReserved: "All rights reserved.",
    
    // Common
    readMore: "Read more",
    loading: "Loading...",
    new: "NEW",
    italy: "Italy"
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('it');

  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && (savedLang === 'it' || savedLang === 'en')) {
      setLanguage(savedLang);
    }
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
